import mom from 'moment'
import Vue from 'vue'

Vue.filter('localDate', (value) => {
    if(value){
        return mom(String(value)).local();
    }
})


// WEBPACK FOOTER //
// ./src/utilities/localDate_filter.js